import { Guid } from '@ebeihilfe/core';

export class AntragUpdateDto {
  public concurrency: Date;
  public antragId: Guid;
  public encryptedMetadata?: string | undefined;
  public encryptedSurveyDaten?: string | undefined;

  constructor(antragId: Guid, concurrency: Date, encryptedMetadata?: string, encryptedSurveyDaten?: string) {
    this.antragId = antragId;
    this.concurrency = concurrency;
    this.encryptedMetadata = encryptedMetadata;
    this.encryptedSurveyDaten = encryptedSurveyDaten;
  }
}
